export type UserPermissions = {
  viewTranslationInformation: boolean;
  submitNewTranslations: boolean;
  updateTranslations: boolean;
  deactivateOwnUnpublishedTranslations: boolean;
  deactivateAnyPublishedTranslations: boolean;
  approveOrDeclineTranslations: boolean;
};

export enum UserRole {
  ViewOnly = "View-only",
  Contributor = "Contributor",
  Admin = "Admin",
}

export type UserProfile = {
  userName: string;
  userDisplayName: string;
  role: UserRole;
  permissions: UserPermissions;
};
